import { helper } from '@ember/component/helper';
import { Channel, Measure } from 'cio/utils/metrics/common';
import { isDeliveryMeasureEnabledForChannel } from 'cio/utils/metrics/measure';

export function isDeliveryMeasureEnabledForChannelHelper([measure, channel]: [Measure, Channel]) {
  return isDeliveryMeasureEnabledForChannel(measure, channel);
}

export default helper(isDeliveryMeasureEnabledForChannelHelper);
